import { useEffect } from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import {
  Box,
  Button,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { getBranchList, } from '../../../store/common/common_action'
import * as error from '../../common/error_strings'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import { callAddFontNirmalaNormal } from '../BranchTransfer/fonts/Nirmala-normal'
import { callAddFontNirmalaBold } from '../BranchTransfer/fonts/Nirmala-bold'
import { Item } from '../../common/snippets'
import Datepicker from '../../common/datePicker'
import {
  Received_Dispatch_From_Branch,
  Receive_ReceivedItem_ChallanNo,
  Receive_ReceivedItem_Consignment_Type,
  Receive_ReceivedItem_Payment_Type,
  Receive_ReceivedItem_vehicleNo,
  Receive_Received_Dispatch_From_City,
  Receive_Received_To_Branch,
  Receive_Received_To_City,
} from '../BranchTransferReceive/Lables'
import DropDownOA from '../../common/dropDownOA'
import DropDown from '../../common/dropDown'
import { From_Date, To_Date } from '../BranchTransfer/Lables'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { getUpdateReceiveItemData } from '../../../store/branchTransferReceive/branchReceive_action'
import { clickElement, formatDate2 } from '../../common/helper'
import { API_CACHE_DURATION, branchObj, cityObj } from '../../common/constants'

const ReceivedItem = ({ data, getBranchList, getUpdateReceiveItemData, handleAlert}) => {
  const { common, BranchTransferReceiveReducer } = data
  const { receiveDataList } = { ...BranchTransferReceiveReducer }
  const { strtCity, strtBrnch, loginData, cityList, destBrnchList } = { ...common }
  const [searchResult, setSearchResult] = useState(false)
  const [state, setState] = useState({
    filter: false,
    generatePDF: false,
    load: false,
    buttonsShow: false,
  })
  const { filter, generatePDF, load, buttonsShow } = { ...state }
  const [date, setDate] = useState({
    fromDate: null,
    toDate: null,
  })
  const { fromDate, toDate } = { ...date }
  const [receivedState, setReceivedState] = useState({
    fromCity: 'All',
    toCity: '',
    fromBranch: 'All',
    toBranch: '',
    AllBranches: [],
    fromCityData: [],
    toCityData: [],
    toBranchData: [],
    fromBranchData: [], 
    PaymentType: [],
    VehicleNo: [],
    ItemType: [],
    VoucherNo: [],
    PaymentTypeState: '',
    VehicleNoState: '',
    ItemTypeState: '',
    VoucherNoState: '',
  })
  const {
    fromCity,
    toCityData,
    AllBranches,
    fromCityData,
    toBranchData,
    fromBranchData,
    fromBranch,
    toBranch,
    toCity,
    PaymentType,
    VehicleNo,
    ItemType,
    VoucherNo,
    PaymentTypeState,
    VehicleNoState,
    ItemTypeState,
    VoucherNoState,
  } = { ...receivedState }
  const [tableData, setTableData] = useState([])

  function getNumericMonth(monthAbbr) {
    return String(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].indexOf(monthAbbr) + 1).padStart(
      2,
      '0'
    )
  }
 

  //compare betwween two dates of months
  function diffInMonths(from, to) {
    var months = to.getMonth() - from.getMonth() + 12 * (to.getFullYear() - from.getFullYear())

    if (to.getDate() < from.getDate()) {
      var newFrom = new Date(to.getFullYear(), to.getMonth(), from.getDate())
      if (to < newFrom && to.getMonth() == newFrom.getMonth() && to.getYear() % 4 != 0) {
        months--
      }
    }

    return months
  }

  // new code 
  const GroupData = (array) => {
    if (array.length >= 1) {
      var newData = {}
      array?.forEach((item) => {
        if (!(item['FromBranch'] in newData)) {
          newData[item['FromBranch']] = []
        }
        newData[item['FromBranch']].push({
          LRNO: item['LRNO'],
          FromCity: item['FromCity'],
          DispatchDateTime: item['DispatchDateTime'],
          ReceiveDateTime: item['ReceiveDateTime'],
          RecName: item['RecName'],
          Sender: item['Sender'],
          SendingBranch: item['SendingBranch'],
          ReceivingBranch: item['ReceivingBranch'],
          SendingBranch: item['SendingBranch'],
          SendingCity: item['SendingCity'],
          VehicleNo: item['VehicleNo'],
          ChallanNo: item['ChallanNo'],
          PaymentType: item['PaymentType'],
          SubType: item['SubType'],
          NOP: item['NOP'],
          NetAmount: item['NetAmount'],
        })
      })
      let unitTotal = 0
      let NetAmountTotal = 0
      Object.keys(newData)?.map((val) => {
        newData[val].forEach((val) => {
          unitTotal += Number(val.NOP)
          NetAmountTotal += Number(val.NetAmount)
        })

        newData[val]?.push({
          srNo: val + ` Total`,
          NOP: unitTotal.toFixed(2),
          NetAmount: NetAmountTotal.toFixed(2),
          gross: NetAmountTotal,
        })
        // newData[val]?.push({
        //   srNo: newData[val]?.[0].FromCity + ` Total`,
        //   NOP: unitTotal.toFixed(2),
        //   NetAmount: NetAmountTotal.toFixed(2),
        //   gross: NetAmountTotal,
        // })
        newData[val]?.unshift({
          srNo: `Source City : ` + newData[val][0].FromCity,
          RecName: `Source Branch : ` + val,
        })
        unitTotal = 0
        NetAmountTotal = 0
      })
      Object.keys(newData).forEach((item, i) => {
        newData[item]?.forEach((val, i) => {
          if (Object.keys(val).length >= 5) {
            val.srNo = i + 1 - 1
          }
        })
      })
      const mainData = { ...newData }
      let bodyData = []
      Object.keys(mainData)?.map((item) => {
        const data = [...bodyData]
        bodyData = [...data, ...mainData[item]]
      })
      // setTableData(bodyData)
      return bodyData;
    } else {
      setTableData([])
    }
  }

  const CityWiseGroupData = (array) => {
    if (array.length >= 1) {
      var newData = {}
      array?.forEach((item) => {
        if (!(item['FromCity'] in newData)) {
          newData[item['FromCity']] = []
        }
        newData[item['FromCity']].push({
          LRNO: item['LRNO'],
          FromCity: item['FromCity'],
          FromBranch:item['FromBranch'],
          DispatchDateTime: item['DispatchDateTime'],
          ReceiveDateTime: item['ReceiveDateTime'],
          RecName: item['RecName'],
          Sender: item['Sender'],
          SendingBranch: item['SendingBranch'],
          ReceivingBranch: item['ReceivingBranch'],
          SendingBranch: item['SendingBranch'],
          SendingCity: item['SendingCity'],
          VehicleNo: item['VehicleNo'],
          ChallanNo: item['ChallanNo'],
          PaymentType: item['PaymentType'],
          SubType: item['SubType'],
          NOP: item['NOP'],
          NetAmount: item['NetAmount'],
        })
      })
      let data = []
      let unitTotal = 0
      let NetAmountTotal = 0
      Object.keys(newData)?.forEach((val) => {
        const arr = GroupData(newData[val])
        const dataFilter = arr?.filter((item) => Object.keys(item).length === 4)
        dataFilter?.forEach((val) => {
          unitTotal += Number(val.NOP)
          NetAmountTotal += Number(val.NetAmount)
        })
        arr?.push({
          srNo: newData[val]?.[0].FromCity + ` Total`,
          NOP: unitTotal.toFixed(2),
          NetAmount: NetAmountTotal.toFixed(2),
          gross: NetAmountTotal,
        })
         unitTotal = 0
       NetAmountTotal = 0
        data = [...data, ...arr]
      })
      setTableData(data)
    } else {
      setTableData([])
    }
  }


  useEffect(() => {
    if (receiveDataList.status === 'Success') {
      if (receiveDataList?.Data?.Table?.length >= 1) {
        const PaymentType = [...new Set(receiveDataList?.Data?.Table?.map((val) => val.PaymentType))]
        const ItemType = [...new Set(receiveDataList?.Data?.Table?.map((val) => val.SubType))]
        const VehicleNo = [...new Set(receiveDataList?.Data?.Table?.map((val) => val.VehicleNo))]
        const VoucherNo = [...new Set(receiveDataList?.Data?.Table?.map((val) => val.ChallanNo))]
        setReceivedState({
          ...receivedState,
          PaymentType: PaymentType,
          VehicleNo: VehicleNo,
          ItemType: ItemType,
          VoucherNo: VoucherNo,
        })
        // GroupData(receiveDataList?.Data?.Table)
        CityWiseGroupData(receiveDataList?.Data?.Table)
      } else {
        setTableData([])
        setReceivedState({ ...receivedState, PaymentType: [], VehicleNo: [], ItemType: [], VoucherNo: [], TransferType: [] })
      }
    }
  }, [receiveDataList?.Data?.Table])

  useEffect(() => {
    const fromcities = cityList?.filter((val) => val.CityID !== strtCity?.CityID)
    setReceivedState({ ...receivedState, fromCityData: fromcities, fromBranchData: AllBranches })
  }, [AllBranches])

  useEffect(() => {
    const todayDate = new Date().toString().split(' ')
    const year = todayDate[3]
    const day = todayDate[2]
    const month = getNumericMonth(todayDate[1])
    const currentDate = `${year}-${month}-${day}`
    setDate({ ...date, fromDate: currentDate, toDate: currentDate })
  }, [])

  useEffect(() => {
    setReceivedState({ ...receivedState, AllBranches: destBrnchList })
  }, [destBrnchList])

  useEffect(() => {
    if (fromCity !== '') {
      const data = cityList.filter((val) => val.CityID !== fromCity?.CityID)
      const branch = AllBranches.filter((val) => val.CityID === fromCity?.CityID)
      setReceivedState({ ...receivedState, toCityData: data, fromBranchData: branch })
    }
  }, [fromCity])

  useEffect(() => {
    if (toCity !== '') {
      const branch = AllBranches.filter((val) => val.CityID === toCity?.CityID)
      setReceivedState({ ...receivedState, toBranchData: branch })
    }
  }, [toCity])
  useEffect(() => {
    getBranchList(loginData, fromCity?.CityID, 2, true, API_CACHE_DURATION)
  }, [])
  //All use Effect End
  const handleChange = (e, id) => {
    switch (id) {
      case 'fromdate':
        const Fromdate = e?._d?.toString()?.split(' ')
        const fromyear = Fromdate?.[3]
        const fromday = Fromdate?.[2]
        const frommonth = getNumericMonth(e?._d?.toString()?.split(' ')?.[1])
        const fromcurrentDate = `${fromyear}-${frommonth}-${fromday}`
        setDate({ ...date, fromDate: fromcurrentDate })
        break
      case 'Todate':
        const Todate = e?._d?.toString()?.split(' ')
        const year = Todate?.[3]
        const day = Todate?.[2]
        const month = getNumericMonth(e?._d?.toString()?.split(' ')?.[1])
        const currentDate = `${year}-${month}-${day}`
        setDate({ ...date, toDate: currentDate })
        break
      default:
        break
    }
  }
  const printClick = () => {
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontNirmalaBold])
    jsPDF.API.events.push(['addFonts', callAddFontNirmalaNormal])

    const HeaderColumn = [
      {
        headerName: 'From Date',
        exportHead: 'From Date',
        field: 'FromDate',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'To Date',
        exportHead: 'To Date',
        field: 'ToDate',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Dispatch From City',
        exportHead: 'Dispatch From City',
        field: 'DispatchFromCity',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Dispatch From Branch',
        exportHead: 'Dispatch From Branch',
        field: 'DispatchFromBranch',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Received To City',
        exportHead: 'Received To City',
        field: 'ReceivedToCity',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Received To Branch',
        exportHead: 'Received To Branch',
        field: 'ReceivedToBranch',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
    ]

    const columnDefs = [
      {
        headerName: 'Sr. No.',
        exportHead: 'SR',
        field: 'srNo',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'LR No.',
        exportHead: 'LR No.',
        field: 'LRNO',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Dispatch Date',
        exportHead: 'Dispatch Date',
        field: 'DispatchDateTime',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Received Date',
        exportHead: 'Received Date',
        field: 'ReceiveDateTime',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Dispatch By Branch',
        exportHead: 'Dispatch By Branch',
        field: 'SendingBranch',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
      {
        headerName: 'Received By Branch',
        exportHead: 'Received By Branch',
        field: 'ReceivingBranch',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
      {
        headerName: 'Sender Name',
        exportHead: 'Sender Name',
        field: 'Sender',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Receiver Name',
        exportHead: 'Receiver Name',
        field: 'RecName',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Vehicle No',
        exportHead: 'Vehicle No',
        field: 'VehicleNo',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
      {
        headerName: 'Challan No.',
        exportHead: 'Challan No.',
        field: 'ChallanNo',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
      {
        headerName: 'Pay. Type',
        exportHead: 'Pay. Type',
        field: 'PaymentType',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
      {
        headerName: 'Cons. Type',
        exportHead: 'Cons. Type',
        field: 'SubType',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
      {
        headerName: 'Units',
        exportHead: 'Units',
        field: 'NOP',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
      {
        headerName: 'Gross Amount',
        exportHead: 'Gross Amount',
        field: 'NetAmount',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
    ]

    const pdfColumns = columnDefs.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderColumns = HeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderData = [
      {
        FromDate: formatDate2(fromDate),
        ToDate: formatDate2(toDate),
        DispatchFromCity: fromCity == 'All' ? 'Multiple Cities' : fromCity.CityName,
        DispatchFromBranch: fromBranch == 'All' ? 'Multiple Branches' : fromBranch.BranchName,
        ReceivedToCity:
          loginData.IsAdmin == 1 || loginData.IsBranchAdmin == 1 || loginData.IsMTPLAdmin == 1 ? toCity?.CityName : strtCity.CityName,
        ReceivedToBranch:
          loginData.IsAdmin == 1 || loginData.IsBranchAdmin == 1 || loginData.IsMTPLAdmin == 1
            ? toBranch?.BranchName
            : strtBrnch.BranchName,
      },
    ]
    // const doc = new jsPDF({
    //   orientation: 'l',
    //   format: 'a4',
    // })
    const doc = new jsPDF()

    doc.autoTableSetDefaults({
      headStyles: { fontSize: 6, width: 'auto', halign: 'left', fillColor: [30, 89, 167] },
    })

    var totalPagesExp = '{total_pages_count_string}'
    const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
      const doc = data.doc

      // Footer
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
      doc.setDrawColor(0, 0, 0)
      doc.setLineWidth(0.2)
      doc.line(0, pageHeight - 7, pageWidth, pageHeight - 7)
      var str = 'Page : ' + doc.internal.getNumberOfPages()
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }
      doc.setFontSize(9)
      doc.text(str, 5 + 260, pageHeight - 2)
      doc.setFont('Nirmala', 'normal')
      doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 5, pageHeight - 2)
      doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, 5 + 150, pageHeight - 2)
    }

    let drawCell = function (data) {
      var rows = data.table.body
      rows.map((val) => {
        if (Object.keys(val.raw).length == 2) {
          val.cells[0].colSpan = 7
          val.cells[0].styles.font = 'Nirmala'
          val.cells[0].styles.fontStyle = 'bold'
          val.cells[0].styles.fontSize = '7'
          val.cells[0].styles.halign = 'left'
          val.cells[0].styles.fillColor = [245, 250, 254]

          val.cells[7].colSpan = 7
          val.cells[7].styles.font = 'Nirmala'
          val.cells[7].styles.fontStyle = 'bold'
          val.cells[7].styles.fontSize = '7'
          val.cells[7].styles.fillColor = [245, 250, 254]
        }
        if (Object.keys(val.raw).length == 4) {
          val.cells[0].colSpan = 12
          val.cells[0].styles.font = 'Nirmala'
          val.cells[0].styles.fontStyle = 'bold'
          val.cells[0].styles.fontSize = '7'
          val.cells[0].styles.halign = 'right'
          val.cells[0].styles.fillColor = [208, 220, 238]

          val.cells[12].colSpan = 1
          val.cells[12].styles.font = 'Nirmala'
          val.cells[12].styles.fontStyle = 'bold'
          val.cells[12].styles.fontSize = '7'
          val.cells[12].styles.halign = 'right'
          val.cells[13].styles.minCellWidth = 10
          val.cells[12].styles.fillColor = [208, 220, 238]

          val.cells[13].colSpan = 1
          val.cells[13].styles.font = 'Nirmala'
          val.cells[13].styles.fontStyle = 'bold'
          val.cells[13].styles.fontSize = '7'
          val.cells[13].styles.halign = 'right'
          val.cells[13].styles.minCellWidth = 15
          val.cells[13].styles.fillColor = [208, 220, 238]
        }
      })
    }

    doc.setProperties({
      title: `Item List.pdf`,
      subject: 'Receive Summary Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })

    autoTable(doc, {
      margin: { top: 19, left: 5, right: 5, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: HeaderData,
      columnStyles: {
        0: { halign: 'left', font: 'Nirmala', fontSize: 8 },
        1: { fontSize: 8, font: 'Nirmala', halign: 'left' },
        2: { fontSize: 8, font: 'Nirmala', halign: 'left' },
        3: { fontSize: 8, font: 'Nirmala', halign: 'left' },
        4: { fontSize: 8, font: 'Nirmala', halign: 'left' },
        5: { fontSize: 8, font: 'Nirmala', halign: 'left' },
        6: { fontSize: 8, font: 'Nirmala', halign: 'left' },
      },
      theme: 'grid',
      headStyles: {
        fillColor: [30, 89, 167],
      },
    })

    autoTable(doc, {
      margin: { top: 20, left: 5, right: 5, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: pdfColumns,
      body: tableData,
      columnStyles: {
        0: { halign: 'right', fontSize: 7,minCellWidth:8 },
        1: { fontSize: 7, font: 'Nirmala' },
        2: { fontSize: 7, font: 'Nirmala' },
        3: { fontSize: 7, font: 'Nirmala' },
        4: { fontSize: 7, font: 'Nirmala',minCellWidth:20 },
        5: { fontSize: 7, font: 'Nirmala',minCellWidth:20 },
        6: { halign: 'left', fontSize: 7, font: 'Nirmala' },
        7: { halign: 'left', fontSize: 7, font: 'Nirmala' },
        8: { halign: 'left', fontSize: 7, font: 'Nirmala' },
        9: { halign: 'right', fontSize: 7,minCellWidth:11 },
        10: { halign: 'left', fontSize: 7, font: 'Nirmala' },
        11: { halign: 'left', fontSize: 7, font: 'Nirmala' },
        12: { halign: 'right', fontSize: 7 },
        13: { halign: 'right', fontSize: 7 },
        14: { halign: 'right', fontSize: 7 },
      },
      theme: 'grid',
      headStyles: {
        fillColor: [30, 89, 167],
      },
      didParseCell: (data) => {
        drawCell(data)
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 5, 8, 10, 10)
        doc.setFontSize(12)
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System', 17, 14)
        doc.setDrawColor(16, 79, 162)
        doc.setLineWidth(0.4)
        doc.line(46, 11, 46, 15)

        doc.setFontSize(12)
        doc.setTextColor(16, 79, 162)
        doc.text(`Received Item List`, 48, 14)

        doc.setFontSize(10).setFont(undefined, 'bold')
        doc.setTextColor(0, 0, 0)
        doc.text('Company Name : ', 130, 14)
        doc.setFontSize(9).setFont(undefined, 'normal')
        doc.text(loginData?.strCompanyName, 160, 14)
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    doc.setFont('Nirmala')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    setTimeout(() => {
      setState({ ...state, generatePDF: false, load: true })
      document.getElementById('Receiveoutput').data = doc.output('datauristring', 'Item List.pdf')
    }, 2000)
  }

  const onClick = (id) => {
    switch (id) {
      case 'Search':
        var g1 = new Date(fromDate)
        var g2 = new Date(toDate)
        if (diffInMonths(g1, g2) !== 0) {
          handleAlert('Select More Then One Month')
        } else {
          if (g1.getTime() <= g2.getTime()) {
            // if()
            if (loginData.IsAdmin == 1 || loginData.IsBranchAdmin == 1 || loginData.IsMTPLAdmin == 1) {
              if (toCity === '') {
                handleAlert('Select Received To City')
              } else if (toBranch === '') {
                handleAlert(error.SELECT_RECEIVE_TO_Branch)
              } else {
                setSearchResult(true)
                setState({ ...state, buttonsShow: true })
                const obj = {
                  intFromCityID: fromCity === 'All' ? 0 : fromCity.CityID,
                  intFromBranchID: fromBranch === 'All' ? 0 : fromBranch.BranchID,
                  intToCityID: toCity.CityID,
                  intToBranchID: toBranch.BranchID,
                  dtFrom: fromDate,
                  dtTo: toDate,
                }
                getUpdateReceiveItemData(loginData, obj)
              }
            } else {
              setSearchResult(true)
              setState({ ...state, buttonsShow: true })
              const obj = {
                intFromCityID: fromCity === 'All' ? 0 : fromCity.CityID,
                intFromBranchID: fromBranch === 'All' ? 0 : fromBranch.BranchID,
                intToCityID: strtCity.CityID,
                intToBranchID: strtBrnch.BranchID,
                dtFrom: fromDate,
                dtTo: toDate,
              }
              getUpdateReceiveItemData(loginData, obj)
            }
          } else {
            handleAlert('Correct Your Selected Date')
          }
        }

        break
      case 'ExportPDF':
        // setState({...state,load:false})
        setSearchResult(false)
        printClick()
        break
      case 'PrintPDF':
        // setState({...state,load:false})
        setSearchResult(false)
        printClick()
        break
      case 'Back':
        const data = document.getElementById('Receiveoutput')
        data.innerHTML = ''
        setState({ ...state, load: false })
        setSearchResult(true)
        break
      default:
        break
    }
  }

  const filtered = (id) => {
    switch (id) {
      case 'ResetBTN':
        if (PaymentTypeState !== '') {
          clickElement('receivePaymentType')
        }
        if (VehicleNoState !== '') {
          clickElement('receiveVehicleNo')
        }
        if (ItemTypeState !== '') {
          clickElement('receiveConsignmentType')
        }
        if (VoucherNoState !== '') {
          clickElement('receiveChallanNo')
        }
        setReceivedState({
          ...receivedState,
          PaymentTypeState: '',
          VehicleNoState: '',
          ItemTypeState: '',
          VoucherNoState: '',
        })
        // GroupData(receiveDataList?.Data?.Table)
        CityWiseGroupData(receiveDataList?.Data?.Table)
        break
      case 'Filterbtn':
        if (receiveDataList?.Data?.Table?.length >= 1) {
          const data = receiveDataList?.Data?.Table?.filter(
            (item) =>
              (PaymentTypeState ? item.PaymentType === PaymentTypeState : item.PaymentType !== PaymentTypeState) &&
              (VoucherNoState ? item.ChallanNo === VoucherNoState : item.ChallanNo !== VoucherNoState) &&
              (VehicleNoState ? item.VehicleNo === VehicleNoState : item.VehicleNo !== VehicleNoState) &&
              (ItemTypeState ? item.SubType === ItemTypeState : item.SubType !== ItemTypeState)
          )
          // GroupData(data)
          CityWiseGroupData(data)
        }
        break
      default:
        break
    }
  }

  const InsideRowContent = ({ item, index }) => {
    return (
      <>
        <TableRow className="receivedTr" key={index}>
          {Object.keys(item).length == 2 ? (
            <>
              <TableCell className="receivedTD" style={{ fontWeight: 'bold', background: 'F5FAFE' }} colSpan={7}>
                {item.srNo}
              </TableCell>
              <TableCell className="receivedTD" style={{ fontWeight: 'bold', background: 'F5FAFE' }} colSpan={6}>
                {item.ReceivingBranch}
              </TableCell>
            </>
          ) : Object.keys(item).length == 4 ? (
            <>
              <TableCell
                className="receivedTD"
                style={{ fontWeight: 'bold', background: 'rgb(208, 220, 238)', textAlign: 'right' }}
                colSpan={12}
              >
                {item.srNo}
              </TableCell>
              <TableCell
                className="receivedTD"
                style={{ fontWeight: 'bold', background: 'rgb(208, 220, 238)', textAlign: 'right' }}
                colSpan={1}
              >
                {item.NOP}
              </TableCell>
              <TableCell
                className="receivedTD"
                style={{ fontWeight: 'bold', background: 'rgb(208, 220, 238)', textAlign: 'right' }}
                colSpan={1}
              >
                {item.NetAmount}
              </TableCell>
            </>
          ) : (
            <>
              <TableCell className="receivedTD">{item.srNo}</TableCell>
              <TableCell className="receivedTD">{item.LRNO}</TableCell>
              <TableCell className="receivedTD">{item.DispatchDateTime}</TableCell>
              <TableCell className="receivedTD">{item.ReceiveDateTime}</TableCell>
              <TableCell className="receivedTD">{item.Sender}</TableCell>
              <TableCell className="receivedTD">{item.RecName}</TableCell>
              <TableCell className="receivedTD">{item.SendingBranch}</TableCell>
              <TableCell className="receivedTD">{item.ReceivingBranch}</TableCell>
              <TableCell className="receivedTD">{item.VehicleNo}</TableCell>
              <TableCell className="receivedTD">{item.ChallanNo}</TableCell>
              <TableCell className="receivedTD">{item.PaymentType}</TableCell>
              <TableCell className="receivedTD">{item.SubType}</TableCell>
              <TableCell className="receivedTD" style={{ textAlign: 'right' }}>
                {item.NOP}
              </TableCell>
              <TableCell className="receivedTD" style={{ textAlign: 'right' }}>
                {item.NetAmount}
              </TableCell>
            </>
          )}
        </TableRow>
      </>
    )
  }

  return (
    <>
      <Stack className="cancelTransferHeader" sx={{ height: 590 }}>
        <Grid container sx={{ background: '#e1f2fe' }}>
          <Grid item xs={6} md={3}>
            <Item sx={{ background: '#e1f2fe', width: '100%', display: 'flex' }}>
              <Box style={{ width: '50%', marginRight: '14px' }}>
                <div className="input--container date-picker" style={{ width: '100%' }}>
                  <Datepicker
                    className="deliver-date-picker"
                    name={'filter_from_dt'}
                    type="filter_from_dt"
                    // statusChecked={true}
                    dateChange={(date) => {
                      handleChange(date, 'fromdate')
                    }}
                    label={From_Date}
                    disabled={false}
                    // star={true}
                  />
                </div>
              </Box>
              <Box style={{ width: '50%' }}>
                <div className="input--container date-picker" style={{ width: '100%' }}>
                  <Datepicker
                    className="deliver-date-picker"
                    name={'filter_from_dt'}
                    type="filter_from_dt"
                    // statusChecked={true}
                    dateChange={(date) => {
                      handleChange(date, 'Todate')
                    }}
                    label={To_Date}
                    disabled={false}
                    // star={true}
                  />
                </div>
              </Box>
            </Item>
          </Grid>

          <Grid item xs={6} md={3}>
            <Item sx={{ background: '#e1f2fe', display: 'flex' }}>
              <Box style={{ width: '50%', marginRight: '13px' }}>
                <DropDownOA
                  type={Receive_Received_Dispatch_From_City}
                  defaultvalue={'All'}
                  data={[cityObj,...fromCityData] || []}
                  width="100%"
                  searchPlaceholder={`Search City Name`}
                  label={'Dispatch From City'}
                  tabIndex="2"
                  dataKey={`CityName`}
                  idKey={`CityID`}
                  allValues={receivedState}
                  setAllValue={setReceivedState}
                  listWidth={"200px"}
                />
              </Box>
              <Box style={{ width: '50%', marginLeft: '3px' }}>
                <DropDownOA
                  type={Received_Dispatch_From_Branch}
                  label={'Dispatch From Branch'}
                  data={[branchObj,...fromBranchData] || []}
                  width="100%"
                  searchPlaceholder={`Search Branch Name`}
                  dataKey={`BranchName`}
                  idKey={`BranchName`}
                  allValues={receivedState}
                  setAllValue={setReceivedState}
                  defaultvalue={'All'}
                  listWidth={"250px"}
                />
              </Box>
            </Item>
          </Grid>
          <Grid item xs={6} md={2}>
            <Item sx={{ background: '#e1f2fe' }}>
              <DropDownOA
                type={Receive_Received_To_City}
                defaultvalue={loginData.IsAdmin == 1 || loginData.IsBranchAdmin == 1 || loginData.IsMTPLAdmin == 1 ? '' : strtCity.CityName}
                data={toCityData || []}
                width="100%"
                searchPlaceholder={`Search City Name`}
                label={'Received To City'}
                tabIndex="2"
                dataKey={`CityName`}
                idKey={`CityID`}
                allValues={receivedState}
                setAllValue={setReceivedState}
                disabled={loginData.IsAdmin == 1 || loginData.IsBranchAdmin == 1 || loginData.IsMTPLAdmin == 1 ? false : true}
              />
            </Item>
          </Grid>
          <Grid item xs={6} md={2}>
            <Item sx={{ background: '#e1f2fe' }}>
              <DropDownOA
                type={Receive_Received_To_Branch}
                defaultvalue={
                  loginData.IsAdmin == 1 || loginData.IsBranchAdmin == 1 || loginData.IsMTPLAdmin == 1 ? '' : strtBrnch.BranchName
                }
                data={toBranchData || []}
                width="100%"
                searchPlaceholder={`Search Branch Name`}
                label={'Received To Branch'}
                disabled={loginData.IsAdmin == 1 || loginData.IsBranchAdmin == 1 || loginData.IsMTPLAdmin == 1 ? false : true}
                tabIndex="2"
                dataKey={`BranchName`}
                idKey={`BranchID`}
                allValues={receivedState}
                setAllValue={setReceivedState}
              />
            </Item>
          </Grid>
          <Grid item xs={6} md={1}>
            <Item sx={{ background: '#e1f2fe' }}>
              <Button
                variant="contained"
                id="Receivebtn"
                sx={{ width: '100%' }}
                style={{ backgroundColor: '#fe5200', fontSize: '15px', textTransform: 'Uppercase', color: '#fff', fontWeight: 'bold' }}
                onClick={() => onClick('Search')}
              >
                Search
              </Button>
            </Item>
          </Grid>

          <Grid item xs={6} md={1}>
            <Item sx={{ background: '#e1f2fe', display: 'flex' }}>
              {filter ? (
                <>
                  <div onClick={() => setState({ ...state, filter: false })} className="morefilterstyle">
                    {' '}
                    Close Filter{' '}
                  </div>
                  <ArrowDropUpIcon onClick={() => setState({ ...state, filter: false })} className="receivedItemIcon" />
                </>
              ) : (
                <>
                  <div onClick={() => setState({ ...state, filter: true })} className="morefilterstyle">
                    {' '}
                    More Filter{' '}
                  </div>
                  <ArrowDropDownIcon onClick={() => setState({ ...state, filter: true })} className="receivedItemIcon" />
                </>
              )}
            </Item>
          </Grid>
        </Grid>
        {filter && (
          <Grid container sx={{ background: '#e1f2fe' }}>
            <Grid item xs={6} md={3}>
              <Item sx={{ background: '#e1f2fe' }}>
                <DropDown
                  type={Receive_ReceivedItem_Payment_Type}
                  data={PaymentType || []}
                  width="100%"
                  searchPlaceholder={`Search ${Receive_ReceivedItem_Payment_Type}`}
                  label={Receive_ReceivedItem_Payment_Type}
                  tabIndex="2"
                  id={Receive_ReceivedItem_Payment_Type}
                  crossIconId={'receivePaymentType'}
                  allValues={receivedState}
                  setAllValue={setReceivedState}
                />
              </Item>
            </Grid>

            <Grid item xs={6} md={3}>
              <Item sx={{ background: '#e1f2fe', display: 'flex', width: '100%' }}>
                <Box style={{ width: '50%', marginRight: '13px' }}>
                  <DropDown
                    type={Receive_ReceivedItem_Consignment_Type}
                    data={ItemType || []}
                    width="100%"
                    searchPlaceholder={`Search ${Receive_ReceivedItem_Consignment_Type}`}
                    label={Receive_ReceivedItem_Consignment_Type}
                    tabIndex="2"
                    id={Receive_ReceivedItem_Consignment_Type}
                    crossIconId={'receiveConsignmentType'}
                    allValues={receivedState}
                    setAllValue={setReceivedState}
                  />
                </Box>
                <Box style={{ width: '50%', marginLeft: '3px' }}>
                  <DropDown
                    type={Receive_ReceivedItem_vehicleNo}
                    data={VehicleNo || []}
                    width="100%"
                    searchPlaceholder={`Search ${Receive_ReceivedItem_vehicleNo}`}
                    label={Receive_ReceivedItem_vehicleNo}
                    tabIndex="2"
                    id={Receive_ReceivedItem_vehicleNo}
                    crossIconId={'receiveVehicleNo'}
                    allValues={receivedState}
                    setAllValue={setReceivedState}
                  />
                </Box>
              </Item>
            </Grid>
            <Grid item xs={6} md={2}>
              <Item sx={{ background: '#e1f2fe' }}>
                <DropDown
                  type={Receive_ReceivedItem_ChallanNo}
                  data={VoucherNo || []}
                  width="100%"
                  searchPlaceholder={`Search ${Receive_ReceivedItem_ChallanNo}`}
                  label={Receive_ReceivedItem_ChallanNo}
                  tabIndex="2"
                  id={Receive_ReceivedItem_ChallanNo}
                  crossIconId={'receiveChallanNo'}
                  allValues={receivedState}
                  setAllValue={setReceivedState}
                />
              </Item>
            </Grid>
            <Grid item xs={6} md={2}>
              <Item sx={{ background: '#e1f2fe' }}>
                <Button
                  variant="contained"
                  id="Receivebtn"
                  sx={{ width: '100%' }}
                  style={{ backgroundColor: '#fe5200', fontSize: '15px', textTransform: 'Uppercase', color: '#fff', fontWeight: 'bold' }}
                  onClick={() => filtered('Filterbtn')}
                >
                  {' '}
                  Filter
                </Button>
              </Item>
            </Grid>
            <Grid item xs={6} md={1} className="itemButtons">
              <Item sx={{ background: '#e1f2fe' }}>
                <Button
                  variant="outlined"
                  sx={{ width: '100%' }}
                  className="receiveitembtn"
                   onClick={() => filtered('ResetBTN')}
                >
                  {' '}
                  Reset
                </Button>
              </Item>
            </Grid>
          </Grid>
        )}
        {buttonsShow && (
          <>
            {load ? (
              <Grid container className="itemButtons">
                <Grid item xs={6} md={11}></Grid>
                <Grid item xs={6} md={1}>
                  <Item>
                    <Button
                      variant="outlined"
                      sx={{ width: '100%' }}
                      className="receiveitembtn"
                      onClick={() => onClick('Back')}
                    >
                      Back
                    </Button>
                  </Item>
                </Grid>
              </Grid>
            ) : (
              <Grid container className="itemButtons">
                <Grid item xs={6} md={6}></Grid>

                <Grid item xs={6} md={2}>
                  <Item>
                    <ReactHtmlTableToExcel
                      id="test-table-xls-button"
                      className="receiveitemExcelBtn"
                      table="table-to-xls"
                      filename="Branch Received Item List"
                      sheet="tablexls"
                      buttonText="Export to Excel"
                    />
                  </Item>
                </Grid>
                <Grid item xs={6} md={2}>
                  <Item>
                    <Button variant="outlined" sx={{ width: '100%' }} className="receiveitembtn" onClick={() => onClick('ExportPDF')}>
                      Export to Pdf
                    </Button>
                  </Item>
                </Grid>
                <Grid item xs={6} md={2}>
                  <Item>
                    <Button
                      variant="outlined"
                      sx={{ width: '100%' }}
                      className="receiveitembtn"
                      onClick={() => onClick('PrintPDF')}
                    >
                      Print
                    </Button>
                  </Item>
                </Grid>
              </Grid>
            )}
          </>
        )}
        {searchResult ? (
          <Stack sx={{ marginLeft: 2, marginRight: 2, height: 350 }}>
            <TableContainer className="lr-popup-table lrModel">
              <Table style={{}} id="table-to-xls" className="table1 table-Received" size="small" aria-label="a dense table">
                <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
                  <TableRow style={{ background: '#d5ecfe', color: 'black' }}>
                    <TableCell className="ReceivedItemHead">Sr No.</TableCell>
                    <TableCell className="ReceivedItemHead">LR No. Manual LR No.</TableCell>
                    <TableCell className="ReceivedItemHead">Dispatch Date</TableCell>
                    <TableCell className="ReceivedItemHead">Received Date</TableCell>
                    <TableCell className="ReceivedItemHead">Sender Name</TableCell>
                    <TableCell className="ReceivedItemHead">Receiver Name</TableCell>
                    <TableCell className="ReceivedItemHead">Dispatch By Branch</TableCell>
                    <TableCell className="ReceivedItemHead">Received By Branch</TableCell>
                    <TableCell className="ReceivedItemHead">Vehicle No.</TableCell>
                    <TableCell className="ReceivedItemHead">Challan No.</TableCell>
                    <TableCell className="ReceivedItemHead">Payment Type</TableCell>
                    <TableCell className="ReceivedItemHead">Consignment Type</TableCell>
                    <TableCell className="ReceivedItemHead">Units</TableCell>
                    <TableCell className="ReceivedItemHead">Gross Amount</TableCell>
                  </TableRow>
                </TableHead>
                {tableData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={14}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '14px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : tableData.length > 1 ? (
                  <TableBody className="filter-data-row">
                    {tableData?.map((item, index) => (
                      <InsideRowContent item={item} index={index} key={index} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
            </TableContainer>
          </Stack>
        ) : (
          <>
            {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
            {load ? (
              <object
                id="Receiveoutput"
                type="application/pdf"
                width="1388"
                height="440"
                title="MTLPL -Cargo System - After Transfer Summary Report"
                aria-label="MTLPL -Cargo System - After Transfer Summary Report"
              ></object>
            ) : (
              ''
            )}
          </>
        )}
      </Stack>
    </>
  )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
  getBranchList,
  getUpdateReceiveItemData,
}

export default connect(mapStateToProps, mapDispatchToProps)(ReceivedItem)
